import { CANNON, CREW, UPGRADES } from "./config.ts";

export type Tier = 0 | 1 | 2;
export interface Livery { figurehead: number; emblem: number; flag: number }
export interface Upgrades { hull: number; guns: number; hold: number }
interface Upgraded { upgrades: Upgrades }

/** Automatic per-crew look: every player crew slot gets a unique triple; NPC ships share the kraken/skull look. */
export function defaultLivery(slot: number, out: Livery): Livery {
  if (slot >= CREW.maxCrews) {
    out.figurehead = 2; out.emblem = 0; out.flag = 0;
  } else {
    out.figurehead = slot % 4;
    out.emblem = Math.floor(slot / 4) % 4;
    out.flag = (slot + Math.floor(slot / 16)) % 4;
  }
  return out;
}

export function tier(n: number): Tier {
  return Math.max(0, Math.min(UPGRADES.maxTier, Math.floor(n) || 0)) as Tier;
}

export const maxBalls = (s: Upgraded): number => UPGRADES.hold.maxBalls[tier(s.upgrades.hold)];
export const maxPlanks = (s: Upgraded): number => UPGRADES.hold.maxPlanks[tier(s.upgrades.hold)];
export const cannonReloadSeconds = (s: Upgraded): number => CANNON.reloadSeconds * UPGRADES.guns.reloadScale[tier(s.upgrades.guns)];
export const floodScale = (s: Upgraded): number => UPGRADES.hull.floodScale[tier(s.upgrades.hull)];
